const slotPools = [
  ["Mon | 6:30 PM IST", "Wed | 7:45 PM IST", "Sat | 10:00 AM IST"],
  ["Tue | 5:00 PM IST", "Thu | 6:00 PM IST", "Sun | 11:30 AM IST"],
  ["Mon | 4:30 PM IST", "Fri | 8:00 PM IST", "Sat | 6:00 PM IST"],
  ["Tue | 7:00 PM IST", "Thu | 4:00 PM IST", "Sun | 5:30 PM IST"],
];

const reviewPairs = [
  [
    "Explains concepts patiently and gives very actionable mock test feedback.",
    "Weekly doubt sessions helped me stay consistent even during exam pressure.",
  ],
  [
    "Great structure, neat notes, and a very calm teaching style.",
    "The classes are practical and easy to revise from the recordings.",
  ],
  [
    "Strong conceptual clarity and very useful exam shortcuts.",
    "I could see my score improving after every weekly review.",
  ],
];

const tutorSeed = [
  {
    id: "prince-vijay",
    name: "Prince Vijay",
    headline: "English, Hindi and French | 3+ yrs Exp",
    experienceYears: 3,
    rating: 4.9,
    subjects: ["English", "Hindi", "French"],
    price: 800,
    shortBio:
      "Graduate from BHU in English Honors. Diploma in French Language. Best tutor for languages.",
    fullBio:
      "Prince Vijay helps board learners and spoken language students build grammar, writing, and confidence. His sessions combine reading practice, speaking drills, and structured revision trackers.",
    qualifications: "BHU English Honors, Diploma in French Language",
    category: "Languages",
    tags: ["English", "French", "Spoken English", "Board Exams"],
    image: "",
  },
  {
    id: "prashant",
    name: "Prashant",
    headline: "Humanities (7-12th) | 6 yrs Exp",
    experienceYears: 6,
    rating: 4.9,
    subjects: ["Humanities", "History", "Civics", "Geography", "Economics"],
    price: 800,
    shortBio:
      "Graduate from Delhi University. Teaches History, Civics, Geography and Economics.",
    fullBio:
      "Prashant designs connected humanities lessons so students remember timelines, causes, and current-affairs links. He is especially effective for mixed board and entrance preparation.",
    qualifications: "Delhi University Graduate",
    category: "Humanities",
    tags: ["Humanities", "CBSE", "State Board", "CUET"],
    image: "",
  },
  {
    id: "sanchita-roy",
    name: "Sanchita Roy",
    headline: "Math Specialist | 3 yrs Exp",
    experienceYears: 3,
    rating: 4.8,
    subjects: ["Mathematics", "JEE/NEET"],
    price: 800,
    shortBio:
      "Calcutta University graduate focused on concept clarity and advanced board questions.",
    fullBio:
      "Sanchita focuses on concept-first mathematics with a strong bridge between board questions and advanced problem sets. Her students use step-by-step error analysis after every practice paper.",
    qualifications: "Calcutta University Graduate",
    category: "Mathematics",
    tags: ["Mathematics", "Boards", "JEE/NEET", "Concept Clarity"],
    image: "",
  },
  {
    id: "swagatam-ghosh",
    name: "Swagatam Ghosh",
    headline: "Science Educator | 5 yrs Exp",
    experienceYears: 5,
    rating: 4.6,
    subjects: ["Physics", "Science", "ICSE/CBSE"],
    price: 700,
    shortBio: "Graduate from NIT Durgapur. Strong in Physics conceptual clarity.",
    fullBio:
      "Swagatam teaches science through visual examples, derivation walkthroughs, and board-style problem banks. He is known for removing fear around physics numericals.",
    qualifications: "NIT Durgapur Graduate",
    category: "Science",
    tags: ["Physics", "ICSE", "CBSE", "Concepts"],
    image: "",
  },
  {
    id: "ashok-verma",
    name: "Ashok Verma",
    headline: "Sainik Prep and English | 8 yrs",
    experienceYears: 8,
    rating: 4.5,
    subjects: ["Sainik Prep", "Spoken English", "Grammar"],
    price: 500,
    shortBio:
      "Sainik School alumnus specialised in grammar drills and fluent spoken English.",
    fullBio:
      "Ashok pairs disciplined practice routines with language fluency work for school entrance prep. His classes include grammar drills, interview readiness, and confidence building.",
    qualifications: "Sainik School Alumnus",
    category: "Entrance + English",
    tags: ["Sainik Prep", "Spoken English", "Grammar", "Foundation"],
    image: "",
  },
  {
    id: "arjun-patel",
    name: "Arjun Patel",
    headline: "Biology Expert | 7 yrs Exp",
    experienceYears: 7,
    rating: 4.9,
    subjects: ["Biology", "NEET", "CBSE Biology"],
    price: 750,
    shortBio:
      "In-depth diagram practice and conceptual biology focus for medical aspirants.",
    fullBio:
      "Arjun makes biology retention easier with memory anchors, labelled diagrams, and chapter-wise NEET boosters. He is especially strong with revision scheduling.",
    qualifications: "Medical Entrance Mentor",
    category: "Biology",
    tags: ["Biology", "NEET", "Diagrams", "Medical"],
    image: "",
  },
  {
    id: "neha-sharma",
    name: "Neha Sharma",
    headline: "IIT Delhi Alumna | 8 yrs Exp",
    experienceYears: 8,
    rating: 4.9,
    subjects: ["Mathematics", "JEE Advanced"],
    price: 900,
    shortBio:
      "Expert in complex calculus and algebra with a strong JEE track record.",
    fullBio:
      "Neha specialises in advanced mathematics for ambitious learners. Her sessions blend concept mapping, high-level question ladders, and timed mock review for JEE-focused students.",
    qualifications: "IIT Delhi Alumna",
    category: "JEE Mathematics",
    tags: ["Mathematics", "JEE Advanced", "Calculus", "Algebra"],
    image: "",
  },
  {
    id: "rahul-cheema",
    name: "Rahul Cheema",
    headline: "NDA Expert | 4 yrs Exp",
    experienceYears: 4,
    rating: 4.7,
    subjects: ["NDA Prep", "Maths", "SSB Foundation"],
    price: 600,
    shortBio: "Specialist in NDA mathematics and SSB interview foundation.",
    fullBio:
      "Rahul supports defence aspirants with mathematics drills, time-bound practice, and confidence-oriented interview basics. He keeps preparation highly structured and measurable.",
    qualifications: "Defence Entrance Mentor",
    category: "Defence Prep",
    tags: ["NDA", "Maths", "SSB", "Defence"],
    image: "",
  },
  {
    id: "ananya-singh",
    name: "Ananya Singh",
    headline: "Bihar BSSC and History | 5 yrs Exp",
    experienceYears: 5,
    rating: 4.8,
    subjects: ["Bihar BSSC", "History", "State Board"],
    price: 500,
    shortBio:
      "Patna University alumna. Excellent for State Boards and Bihar BSSC GS preparation.",
    fullBio:
      "Ananya brings strong general studies structure to Bihar-focused preparation. She uses layered notes, history timelines, and daily recall routines.",
    qualifications: "Patna University Alumna",
    category: "State Exams",
    tags: ["Bihar BSSC", "History", "GS", "State Board"],
    image: "",
  },
  {
    id: "vikram-joon",
    name: "Vikram Joon",
    headline: "Chemistry Expert | 6 yrs Exp",
    experienceYears: 6,
    rating: 4.9,
    subjects: ["Organic Chemistry", "JEE", "Chemistry"],
    price: 850,
    shortBio:
      "IIT Kanpur graduate who makes organic chemistry formulas easier to retain.",
    fullBio:
      "Vikram simplifies organic chemistry using mechanism stories, reaction maps, and spaced revision. He balances board scoring patterns with entrance-style challenges.",
    qualifications: "IIT Kanpur Graduate",
    category: "Chemistry",
    tags: ["Chemistry", "Organic", "JEE", "Revision"],
    image: "",
  },
  {
    id: "priya-desai",
    name: "Priya Desai",
    headline: "Political Science | 5 yrs Exp",
    experienceYears: 5,
    rating: 4.8,
    subjects: ["Polity", "CUET UG", "Political Science"],
    price: 600,
    shortBio:
      "JNU scholar with strong command of Indian Constitution and the CUET arts domain.",
    fullBio:
      "Priya helps arts students connect constitutional ideas to current examples and exam formats. Her classes are crisp, discussion-led, and excellent for CUET preparation.",
    qualifications: "JNU Scholar",
    category: "Polity",
    tags: ["Polity", "CUET UG", "Political Science", "Arts"],
    image: "",
  },
  {
    id: "rohan-gupta",
    name: "Rohan Gupta",
    headline: "Commerce Specialist | 4 yrs",
    experienceYears: 4,
    rating: 4.9,
    subjects: ["Accountancy", "Economics", "CBSE"],
    price: 700,
    shortBio:
      "SRCC Delhi graduate who simplifies Accounts and Economics for board students.",
    fullBio:
      "Rohan makes commerce chapters easier with practical examples, ledger drills, and graph-based explanations. He is a strong fit for boards and CUET commerce tracks.",
    qualifications: "SRCC Delhi Graduate",
    category: "Commerce",
    tags: ["Accountancy", "Economics", "CBSE", "Commerce"],
    image: "",
  },
  {
    id: "amit-kumar",
    name: "Amit Kumar",
    headline: "Physics (JEE) | 7 yrs Exp",
    experienceYears: 7,
    rating: 4.7,
    subjects: ["Physics", "JEE"],
    price: 800,
    shortBio:
      "IIT Roorkee alumnus focused on mechanics and modern physics numericals.",
    fullBio:
      "Amit works best with learners who need sharper numerical solving discipline. He combines derivation clarity with regular mixed-topic physics tests.",
    qualifications: "IIT Roorkee Alumnus",
    category: "Physics",
    tags: ["Physics", "JEE", "Mechanics", "Modern Physics"],
    image: "",
  },
  {
    id: "sneha-reddy",
    name: "Sneha Reddy",
    headline: "IT / ADCA Expert | 5 yrs Exp",
    experienceYears: 5,
    rating: 4.8,
    subjects: ["Computer Science", "ADCA", "Python", "Java"],
    price: 600,
    shortBio:
      "BITS Pilani graduate teaching ADCA, Python, Java, and practical office skills.",
    fullBio:
      "Sneha blends employable digital skills with strong conceptual basics. She supports students with typing, office tools, programming logic, and beginner-friendly projects.",
    qualifications: "BITS Pilani Graduate",
    category: "Computer Skills",
    tags: ["Computer Science", "ADCA", "Python", "Office Skills"],
    image: "",
  },
  {
    id: "manish-tiwari",
    name: "Manish Tiwari",
    headline: "Hindi and Sanskrit | 10 yrs Exp",
    experienceYears: 10,
    rating: 4.7,
    subjects: ["Hindi", "Sanskrit"],
    price: 500,
    shortBio:
      "BHU alumnus with excellent command of Hindi Vyakaran and Sanskrit grammar.",
    fullBio:
      "Manish uses rooted explanations and memorisation techniques to make language scoring reliable. He is a dependable guide for grammar-heavy board preparation.",
    qualifications: "BHU Alumnus",
    category: "Languages",
    tags: ["Hindi", "Sanskrit", "Grammar", "Board Exams"],
    image: "",
  },
  {
    id: "kavita-mehra",
    name: "Kavita Mehra",
    headline: "Business Studies | 6 yrs Exp",
    experienceYears: 6,
    rating: 4.9,
    subjects: ["Business Studies", "CUET"],
    price: 900,
    shortBio:
      "IIM Ahmedabad alumna who makes business concepts practical and easy.",
    fullBio:
      "Kavita translates business studies into practical, memorable frameworks. Her lessons help students answer with clarity, structure, and real-world relevance.",
    qualifications: "IIM Ahmedabad Alumna",
    category: "Business Studies",
    tags: ["Business Studies", "CUET", "Management Basics", "Commerce"],
    image: "",
  },
  {
    id: "karan-singh",
    name: "Karan Singh",
    headline: "Sainik School Prep | 5 yrs Exp",
    experienceYears: 5,
    rating: 4.8,
    subjects: ["Sainik Prep", "Geography"],
    price: 550,
    shortBio:
      "Sainik School Kapurthala alumnus with strong geography and mapping basics.",
    fullBio:
      "Karan helps younger aspirants gain exam confidence with geography foundations, mapping drills, and steady mock practice tailored for school entrance exams.",
    qualifications: "Sainik School Kapurthala Alumnus",
    category: "Sainik Prep",
    tags: ["Sainik Prep", "Geography", "Foundation", "Mock Practice"],
    image: "",
  },
  {
    id: "alok-ranjan",
    name: "Alok Ranjan",
    headline: "Math Specialist | 6 yrs Exp",
    experienceYears: 6,
    rating: 4.7,
    subjects: ["Mathematics", "NDA/JEE"],
    price: 750,
    shortBio:
      "NIT Patna alumnus using real-world examples to teach complex mathematics.",
    fullBio:
      "Alok is a strong fit for students who want mathematics to feel practical and visual. He uses step ladders, real-life analogies, and topic-wise progress sheets.",
    qualifications: "NIT Patna Alumnus",
    category: "Mathematics",
    tags: ["Mathematics", "NDA", "JEE", "Real-world Examples"],
    image: "",
  },
  {
    id: "zara-khan",
    name: "Zara Khan",
    headline: "Economics Expert | 4 yrs Exp",
    experienceYears: 4,
    rating: 4.8,
    subjects: ["Macro / Micro Economics", "CBSE", "Economics"],
    price: 600,
    shortBio:
      "Jamia Millia Islamia scholar who makes graphs and curves easier to understand.",
    fullBio:
      "Zara demystifies economics with visual graph walkthroughs, short revision capsules, and quick-writing frameworks for board-style answers.",
    qualifications: "Jamia Millia Islamia Scholar",
    category: "Economics",
    tags: ["Economics", "CBSE", "Graphs", "Commerce"],
    image: "",
  },
  {
    id: "deepak-verma",
    name: "Deepak Verma",
    headline: "Chemistry (NEET) | 8 yrs Exp",
    experienceYears: 8,
    rating: 4.9,
    subjects: ["Chemistry", "NEET/JEE"],
    price: 850,
    shortBio:
      "IIT Kharagpur graduate solving physical chemistry numericals with speed and clarity.",
    fullBio:
      "Deepak helps aspirants move faster on physical chemistry with shortcuts, numericals, and precision-oriented error correction. He is highly rated for intensive exam prep.",
    qualifications: "IIT Kharagpur Graduate",
    category: "Chemistry",
    tags: ["Chemistry", "NEET", "JEE", "Numericals"],
    image: "",
  },
  {
    id: "priya-verma",
    name: "Priya Verma",
    headline: "Maths Specialist | 8+ years teaching experience",
    experienceYears: 8,
    rating: 4.8,
    subjects: ["Mathematics", "Board Exams", "JEE Advanced"],
    price: 820,
    shortBio:
      "Focused on board exam success and JEE Advanced with small batches, personalised homework, and regular progress reports.",
    fullBio:
      "Priya Verma leads board-focused mathematics cohorts with crisp notes, strategic homework, and monthly mock reviews. She is featured in Dreameer's live class preview because of her consistent score-improvement model.",
    qualifications: "Featured Live Class Mentor",
    category: "Featured Maths",
    tags: ["Mathematics", "Board Exams", "JEE Advanced", "Mock Tests"],
    image: "",
  },
];

export const sampleTutors = tutorSeed.map((tutor, index) => {
  const pair = reviewPairs[index % reviewPairs.length];
  return {
    ...tutor,
    availabilitySlots: slotPools[index % slotPools.length],
    reviews: [
      {
        name: `${tutor.name.split(" ")[0]} Student`,
        rating: tutor.rating,
        quote: pair[0],
      },
      {
        name: `${tutor.name.split(" ")[0]} Parent`,
        rating: Math.max(4.5, tutor.rating - 0.1),
        quote: pair[1],
      },
    ],
  };
});
